import videojs from "video.js";

if (document.getElementById('newsDetailVideo')) {
    new videojs('newsDetailVideo');
}
